import React from 'react';
import MainLayout from '../layouts/MainLayout';

const WeatherPage: React.FC = () => {
  return (
    <MainLayout>
      <div className="page-banner">
        <div className="container">
          <h1>Weather Information</h1>
          <p>Current conditions at Fallen Leaf Lake</p>
        </div>
      </div>

      <section className="weather-section">
        <div className="container">
          <h2>Today's Weather</h2>
          <p>Content from the static site will be integrated here.</p>
        </div>
      </section>
    </MainLayout>
  );
};

export default WeatherPage; 